import React, { useEffect, useRef, useState, useMemo, useContext } from "react"
import { useHistory } from "react-router-dom"
// import ContentLoader from "react-content-loader"
import {
  formatVehiclePlate,
  desensitizedVin,
  formatTimestampToTxt
} from '../../../utils/common'
import {
  isErrorData,
  calcRatio,
  formatEnergyData,
  getWeekOptionsForEnergyInfo
} from '../utils'
import styles from "./index.module.scss"
import { reportData } from "../../../utils/report-data"
import useECharts from "@/hooks/useEcharts"
import useQuery from "@/hooks/useQuery"
import MessageBox from "@/components/message-box"
import Picker from "@/components/Picker"
// import VehiclePicker from "@/components/vehicle-picker"
import {
  ErrorPlaceholder,
  EmptyPlaceholder,
} from "../../../components/placeholder"
import LoadingPage from "@/components/loading-page"
import {
  getVehicleList,
  getVehicleInfo,
  getWeekEnergyData
} from '@/api/energy-report'
import { ThemeModeContext } from "../../../ThemeModeContext"
import './reset.scss'
import  * as echarts from 'echarts'

interface LineDataItem {
  timeRange: string,
  timeList: string[],
  data: Array<number | string>
}

interface TimeRangeItem {
  value: number[],
  label: string
}

interface vehicleItem {
  vin: string
  plateNo: string | undefined
  validStartTime: number,
  validEndTime: number,
  vehicleTypeSaleName: string
  supported: boolean
}

interface DistributionData {
  type: string,
  thisCycleValue: any,
  energyRatio: number,
  rangeOfChange: number | string
}

const DEFAULT_ERROR_MSG = '服务器开小差啦'
const WEEK_LIST = ['一', '二', '三', '四', '五', '六', '日']

// const mockDataJson = {
//   "vin": "LMVXPYYHE28123456",
//   "avgDriveSpeed": 63.132523,
//   "totalDriveMileage": 25.12352,
//   "avgCircumstanceTemperature": 23.023523,
//   "drivePowerDetailsByDays":
//   {
//     "avgPowerOfThisCycle": 14.63453,
//     "avgPowerOfLastCycle": 15.432423,
//     "thisCycleDetails":
//       [
//         {
//           "date": "2023-03-17",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-18",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-19",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-20",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-21",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-22",
//           "avgPower": 14.3
//         },
//         {
//           "date": "2023-03-23",
//           "avgPower": 14.3
//         }
//       ],
//     "lastCycleDetails":
//       [
//         {
//           "date": "2023-03-10",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-11",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-12",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-13",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-14",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-15",
//           "avgPower": 15.4
//         },
//         {
//           "date": "2023-03-16",
//           "avgPower": 15.4
//         }
//       ]
//   },
//   "energyUsageDetail":
//   {
//     "driveTotalConsumption": 107.822,
//     "recycledEnergy": 28.433,
//     "parkingTotalConsumption": 11.112,
//     "driveConsumptionThisCycle":
//       [
//         {
//           "type": "行驶",
//           "value": 9.1123
//         },
//         {
//           "type": "空调",
//           "value": 2.1123
//         },
//         {
//           "type": "雨刮",
//           "value": 2.1123
//         },
//         {
//           "type": "无线充电",
//           "value": 1.1123
//         },
//         {
//           "type": "其他",
//           "value": 1.1123
//         }
//       ],
//     "driveConsumptionLastCycle":
//       [
//         {
//           "type": "行驶",
//           "value": 10.1123
//         },
//         {
//           "type": "空调",
//           "value": 3.1123
//         },
//         {
//           "type": "雨刮",
//           "value": 1.1123
//         },
//         {
//           "type": "无线充电",
//           "value": 1.1123
//         },
//         {
//           "type": "其他",
//           "value": 2.1123
//         }
//       ],
//     "parkingConsumptionThisCycle":
//       [
//         {
//           "type": "烧饼模式",
//           "value": 10.2324
//         },
//         {
//           "type": "空调",
//           "value": 4.1123
//         },
//         {
//           "type": "电池加热",
//           "value": 1.1123
//         },
//         {
//           "type": "无线充电",
//           "value": 1.1123
//         },
//         {
//           "type": "其他",
//           "value": 3.1123
//         }
//       ],
//     "parkingConsumptionLastCycle":
//       [
//         {
//           "type": "烧饼模式",
//           "value": 11.2324
//         },
//         {
//           "type": "空调",
//           "value": 7.1123
//         },
//         {
//           "type": "电池加热",
//           "value": 0.8123
//         },
//         {
//           "type": "无线充电",
//           "value": 0.1123
//         },
//         {
//           "type": "其他",
//           "value": 5.1123
//         }
//       ]
//   },
//   "conclusions":
//     [
//       "开的不错",
//       "下次别开了"
//     ]
// }

// const mockDataJson2 = {
//   "vin": "LMVXPYYHE28123456",
//   "avgDriveSpeed": 63.132523,
//   "totalDriveMileage": 25.12352,
//   "avgDrivePower": 16.7754,
//   "avgCircumstanceTemperature": 23.023523,
//   "driveTotalConsumption": 107.822,
//   "recycledEnergy": 9.9,
//   "parkingTotalConsumption": 11.112,
//   "driveConsumption": [{ "type": "行驶", "value": 9.1123 }, { "type": "空调", "value": 2.1123 }, { "type": "雨刮", "value": 2.1123 }, { "type": "无线充电", "value": 1.1123 }, { "type": "其他", "value": 1.1123 }],
//   "parkingConsumption": [{ "type": "行驶", "value": 10.1123 }, { "type": "空调", "value": 3.1123 }, { "type": "雨刮", "value": 1.1123 }, { "type": "无线充电", "value": 1.1123 }, { "type": "其他", "value": 2.1123 }]
// }

// const vehicles = [
//   { vin: 'L1NSNGHB0LA567890', plateNo: '粤AD07993', vehicleTypeSaleName: 'G9', supported: true },
//   { vin: 'L1NSNGHB0LA444555', plateNo: '粤AD08665', vehicleTypeSaleName: 'P5', supported: true },
//   { vin: 'L1NSNGHB0LA123456', plateNo: '粤AD88798', vehicleTypeSaleName: 'P7i', supported: false }
// ]

// const HomePageLoading = () => (
//   <ContentLoader viewBox="0 0 375 750">
//     <rect x="26" y="8" rx="5" ry="5" width="152" height="28" />
//     <rect x="200" y="8" rx="5" ry="5" width="152" height="28" />
//     <rect x="26" y="77" rx="5" ry="5" width="60" height="19" />
//     <rect x="44" y="117" rx="5" ry="5" width="64" height="43" />
//     <rect x="154" y="117" rx="5" ry="5" width="64" height="43" />
//     <rect x="264" y="117" rx="5" ry="5" width="64" height="43" />
//     <rect x="44" y="164" rx="5" ry="5" width="64" height="17" />
//     <rect x="154" y="164" rx="5" ry="5" width="64" height="17" />
//     <rect x="264" y="164" rx="5" ry="5" width="64" height="17" />
//     <rect x="26" y="238" rx="5" ry="5" width="60" height="19" />
//     <rect x="122" y="271" rx="5" ry="5" width="127" height="20" />
//     <rect x="122" y="296" rx="5" ry="5" width="127" height="51" />
//     <rect x="51" y="373" rx="5" ry="5" width="269" height="193" />
//     <rect x="115" y="582" rx="5" ry="5" width="142" height="18" />
//     <rect x="26" y="686" rx="5" ry="5" width="60" height="19" />
//     <rect x="44" y="718" rx="5" ry="5" width="64" height="43" />
//     <rect x="154" y="718" rx="5" ry="5" width="64" height="43" />
//     <rect x="264" y="718" rx="5" ry="5" width="64" height="43" />
//   </ContentLoader>
// )

const App = () => {
  // 从车控入口进，会携带vin参数
  const queryVin = useQuery().get('vin') || ''
  // 从消息推送进，不带vin参数，只携带指定车型参数
  const queryVehicleTypeName = useQuery().get('vehicleTypeName') || ''

  const isSuperErev = useQuery().get('isSuperErev') === 'true'

  const [activeTab, setActiveTab] = useState('electric'); // 初始选中“电耗趋势”
  
  const history = useHistory()

  // 颜色主题
  const themeModeContext = useContext(ThemeModeContext)
  const themeMode = themeModeContext?.mode || 'light'

  const lineChartRef = useRef<any>(null)
  const superErevChartRef = useRef<any>(null)
  const debounceTimer = useRef<any>(null)
  const timeRangeOptions = useRef<TimeRangeItem[]>([])
  const currentVin = useRef<string>('')

  const [beforeInit, setBeforeInit] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isEmptyPage, setIsEmptyPage] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const [vehicleList, setVehicleList] = useState([])
  const [showDateRangePicker, setShowDateRangePicker] = useState(false)
  // const [showVehiclePicker, setShowVehiclePicker] = useState(false)

  const [currentVehicleInfo, setCurrentVehicleInfo] = useState<vehicleItem>({
    vin: '',
    plateNo: '',
    validStartTime: 0,
    validEndTime: 0,
    vehicleTypeSaleName: '',
    supported: true
  })
  const [energyDataSummary, setEnergyDataSummary] = useState<any>({
    avgCircumstanceTemperature: '',
    avgDriveSpeed: '',
    totalDriveMileage: '',
    updateTime: '',
    drivePowerDetailsByDays: {},
    energyUsageDetail: {},
    conclusions: []
  })

  // echarts
  const [lineData, setLineData] = useState<LineDataItem[]>([])
  const [xLabels, setXLabels] = useState<string[]>([])

  // superErev 增程车 echarts
  const [superErevlineData, setSuperErevLineData] = useState<LineDataItem[]>([])
  const [superErevXLabels, setSuperErevXLabels] = useState<string[]>([])
  // picker
  const [dateValues, setDateValues] = useState<any>({ label: '' })
  const [dateOptions, setDateOptions] = useState<any>({ label: [] })
  // cycleBar
  const [currentCycle, setCurrentCycle] = useState('')
  const [lastCycle, setLastCycle] = useState('')
  // TOP5能耗分布数据[{ type, thisCycleValue, energyRatio, rangeOfChange }]
  const [distributionType, setDistributionType] = useState('drive') // drive | parking
  const driveEnergyDistributionData = useRef<DistributionData[]>([])
  const parkingEnergyDistributionData = useRef<DistributionData[]>([])
  const [maxAvgPower, setMaxAvgPower] = useState(0)
  //superErev 增程车 maxAvgPower
  const [superErevmaxAvgPower, setSuperErevMaxAvgPower] = useState(0)

  const [electricChart, setElectricChart] = useState<any>(null)
  const [fuelChart, setFuelChart] = useState<any>(null)

  const lineChartOption = useMemo(() => {
    const defaultColorMap = {
      xLineColor: 'rgba(0, 0, 0, 0.1)',
      xLabelsColor: '#B3B3B3',
      yLineColor: 'rgba(0, 0, 0, 0.2)',
      yLabelsColor: '#B3B3B3',
      // xAxisLineColor: 'rgba(0, 0, 0, 0.1)',
      energyColor: '#a4ce4c',
      adEnergyColor: 'rgba(0, 0, 0, 0.26)',
      legendTextColor: 'rgba(0, 0, 0, 0.4)',
      tooltipBgColor: '#FFFFFF'
    }
    const darkColorMap = {
      xLineColor: 'rgba(255, 255, 255, 0.25)',
      xLabelsColor: '#B3B3B3',
      // xAxisLineColor: 'rgba(255, 255, 255, 0.25)',
      yLineColor: 'rgba(255, 255, 255, 0.1)',
      yLabelsColor: '#B3B3B3',
      energyColor: '#7EA34B',
      adEnergyColor: 'rgba(255, 255, 255, 0.25)',
      legendTextColor: 'rgba(255, 255, 255, 0.4)',
      tooltipBgColor: '#1A1B1F'
    }
    const colorMap = themeMode === 'dark' ? darkColorMap : defaultColorMap

    return {
      tooltip: {
        trigger: 'axis',
        backgroundColor: colorMap.tooltipBgColor,
        borderColor: colorMap.tooltipBgColor,
        formatter: function (params) {
          // console.log('params', JSON.stringify(params))
          let tip = ''
          const marker = (color) => `<span style="display:inline-block;margin-right:6px;width:10px;height:10px;background-color:${color};border-radius:1px"></span>`
          if (params !== null && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
              tip += marker(params[i].color) + lineData[i].timeList[params[i].dataIndex] + '&nbsp&nbsp&nbsp' + params[i].value + '<br />'
            }
          }
          return tip
        }
      },
      legend: {
        data: lineData.map(item => {
          return {
            icon: 'roundRect',
            name: item.timeRange
          }
        }),
        selectedMode: false,
        y: 'bottom',
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 16,
        textStyle: {
          fontSize: 12,
          color: colorMap.legendTextColor
        }
      },
      grid: {
        top: '5%',
        left: '6%',
        right: '7%',
        bottom: '16%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisTick: { show: false },
        axisLabel: {
          // color: '#B3B3B3',
          color: colorMap.xLabelsColor,
          fontSize: '10px',
          margin: 15
        },
        data: xLabels,
        // axisLine: {
        //   lineStyle: {
        //     color: colorMap.xAxisLineColor
        //   }
        // }
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            // color: 'rgba(0, 0, 0, 0.2)',
            color: colorMap.yLineColor,
            type: 'dashed',
            width: 0.5
          }
        },
        axisLabel: {
          // color: '#B3B3B3',
          color: colorMap.yLabelsColor,
          fontSize: '10px',
          // formatter: function (value, index) {
          //   return value.toFixed(1)
          // }
        },
        interval: maxAvgPower > 35 ? null : 7,
        max: function (value) {
          return value.max > 35 ? null : 35
        },
        min: function (value) {
          let minLab
          if (value.min >= 0) {
            minLab = null
          } else if (value.min >= -7 && value.min < 0) {
            minLab = -7
          } else if (value.min < -7 && value.min >= -14) {
            minLab = -14
          } else if (value.min < -14 && value.min >= -21) {
            minLab = -21          
          } else {
            minLab = null
          }
          return minLab
        }
      },
      // color: lineData.length > 1 ? ['#a4ce4c', 'rgba(0, 0, 0, 0.26)'] : ['#a4ce4c'],
      color: lineData.length > 1 ? [colorMap.energyColor, colorMap.adEnergyColor] : [colorMap.energyColor],
      series: lineData.map(item => {
        return {
          name: item.timeRange,
          type: 'line',
          data: item.data
        }
      })
    }
  }, [lineData, xLabels, maxAvgPower, themeMode])

  const superErevlineChartOption = useMemo(() => {
    const defaultColorMap = {
      xLineColor: 'rgba(0, 0, 0, 0.1)',
      xLabelsColor: '#B3B3B3',
      yLineColor: 'rgba(0, 0, 0, 0.2)',
      yLabelsColor: '#B3B3B3',
      // xAxisLineColor: 'rgba(0, 0, 0, 0.1)',
      energyColor: '#1990FF',
      adEnergyColor: 'rgba(0, 0, 0, 0.26)',
      legendTextColor: 'rgba(0, 0, 0, 0.4)',
      tooltipBgColor: '#FFFFFF'
    }
    const darkColorMap = {
      xLineColor: 'rgba(255, 255, 255, 0.25)',
      xLabelsColor: '#B3B3B3',
      // xAxisLineColor: 'rgba(255, 255, 255, 0.25)',
      yLineColor: 'rgba(255, 255, 255, 0.1)',
      yLabelsColor: '#B3B3B3',
      energyColor: '#1681E5',
      adEnergyColor: 'rgba(255, 255, 255, 0.25)',
      legendTextColor: 'rgba(255, 255, 255, 0.4)',
      tooltipBgColor: '#1A1B1F'
    }
    const colorMap = themeMode === 'dark' ? darkColorMap : defaultColorMap

    return {
      tooltip: {
        trigger: 'axis',
        backgroundColor: colorMap.tooltipBgColor,
        borderColor: colorMap.tooltipBgColor,
        formatter: function (params) {
          // console.log('params', JSON.stringify(params))
          let tip = ''
          const marker = (color) => `<span style="display:inline-block;margin-right:6px;width:10px;height:10px;background-color:${color};border-radius:1px"></span>`
          if (params !== null && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
              tip += marker(params[i].color) + superErevlineData[i].timeList[params[i].dataIndex] + '&nbsp&nbsp&nbsp' + params[i].value + '<br />'
            }
          }
          return tip
        }
      },
      legend: {
        data: superErevlineData.map(item => {
          return {
            icon: 'roundRect',
            name: item.timeRange
          }
        }),
        selectedMode: false,
        y: 'bottom',
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 16,
        textStyle: {
          fontSize: 12,
          color: colorMap.legendTextColor
        }
      },
      grid: {
        top: '5%',
        left: '6%',
        right: '7%',
        bottom: '16%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisTick: { show: false },
        axisLabel: {
          color: colorMap.xLabelsColor,
          fontSize: '10px',
          margin: 15
        },
        data: superErevXLabels,
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            color: colorMap.yLineColor,
            type: 'dashed',
            width: 0.5
          }
        },
        axisLabel: {
          color: colorMap.yLabelsColor,
          fontSize: '10px',
        },
        interval: superErevmaxAvgPower > 35 ? null : 7,
        max: function (value) {
          return value.max > 35 ? null : 35
        },
        min: function (value) {
          let minLab
          if (value.min >= 0) {
            minLab = null
          } else if (value.min >= -7 && value.min < 0) {
            minLab = -7
          } else if (value.min < -7 && value.min >= -14) {
            minLab = -14
          } else if (value.min < -14 && value.min >= -21) {
            minLab = -21          
          } else {
            minLab = null
          }
          return minLab
        }
      },
      color: superErevlineData.length > 1 ? [colorMap.energyColor, colorMap.adEnergyColor] : [colorMap.energyColor],
      series: superErevlineData.map(item => {
        return {
          name: item.timeRange,
          type: 'line',
          data: item.data
        }
      })
    }
  }, [superErevlineData, superErevXLabels, superErevmaxAvgPower, themeMode])

  // useECharts(lineChartRef, lineChartOption, isLoading)
  // 修改渲染图表的方法
  const renderChart = (chartRef, options, type: 'electric' | 'fuel') => {
    if (!chartRef.current) return
    
    let chart = echarts.getInstanceByDom(chartRef.current)
    
    if (chart) {
      chart.clear()
    } else {
      chart = echarts.init(chartRef.current)
      // 保存图表实例
      if (type === 'electric') {
        setElectricChart(chart)
      } else {
        setFuelChart(chart) 
      }
    }
    
    chart.setOption(options)
  }

  // 修改 resize 处理
  const handleResize = () => {
    electricChart?.resize({ animation: { duration: 300 } })
    fuelChart?.resize({ animation: { duration: 300 } })
  }

// 3. 修改 useEffect,添加主题变化时的重新渲染逻辑
useEffect(() => {
  if (isSuperErev) {
    if (activeTab === 'electric') {
      lineChartRef.current && renderChart(lineChartRef, lineChartOption, 'electric')
    } else {
      superErevChartRef.current && renderChart(superErevChartRef, superErevlineChartOption, 'fuel') 
    }
  } else {
    lineChartRef.current && renderChart(lineChartRef, lineChartOption, 'electric')
  }
  
  window.addEventListener('resize', handleResize)

  return () => {
    electricChart?.dispose()
    fuelChart?.dispose() 
    window.removeEventListener('resize', handleResize)
  }
}, [lineChartOption, superErevlineChartOption, isLoading, themeMode, activeTab])

  useEffect(() => {
    document.title = "能耗数据"

    checkVinBeforeInitData()

    addListener()
    
    return componentWillUnmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const componentWillUnmount = () => {
    removeListener()
    clearTimeout(debounceTimer.current)
  }

  const addListener = () => {
    window.addEventListener('scroll', hideEchartsTooltip, true)
  }

  const removeListener = () => {
    window.removeEventListener('scroll', hideEchartsTooltip, true)
  }

  /**
   * echarts tooltip在移动端没有手指放开就隐藏的选项，必须手动点击消失，这里处理为手动隐藏
   */
  const hideEchartsTooltip = () => {
    if (lineChartRef.current) {
      if (lineChartRef.current.childNodes[1]?.style.display === 'block') {
        lineChartRef.current.childNodes[1].style.display = 'none'
      }
    }
    if (superErevChartRef.current) {
      if (superErevChartRef.current.childNodes[1]?.style.display === 'block') {
        superErevChartRef.current.childNodes[1].style.display = 'none'
      }
    }
  }

  /**
   * 初始化数据前检查，区分是车控入口进还是从消息推送进（url是否带vin参数）
   */
  const checkVinBeforeInitData = async () => {
    handleLoading(true)
    setBeforeInit(false)
    if (queryVin) {
      initData(queryVin)
      // 首页加载埋点
      reportData({pageId: 'P11140', buttonId: 'B001', vin: queryVin})
    } else {
      try {
        await getUserVehicleList()
        if (currentVin.current) {
          initData(currentVin.current)
        } else {
          handleLoading(false)
        }
        // 首页加载埋点
        reportData({pageId: 'P11140', buttonId: 'B001', vin: currentVin.current})
      } catch (error) {
        handleLoading(false)
        console.log('check vin error', error)
      }
    }
  }

  const initData = async (vin: string) => {
    try {
      // const validStartTime = await getUserVehicleInfo(vin)
      const { validStartTime, validEndTime } = await getUserVehicleInfo(vin)
      const weekOptions = handleWeekOptionsData(validStartTime, validEndTime)
      timeRangeOptions.current = weekOptions
      setDateOptions({ label: weekOptions.map(item => item.label) })

      let timeRange
      let currentDateValue
      const userSelectedTimeRange = sessionStorage.getItem('selectedTimeRange')
      // 非首次进入页面，用户已选择时间周期
      if (userSelectedTimeRange) {
        timeRange = JSON.parse(userSelectedTimeRange)
        currentDateValue = weekOptions.find(item => JSON.stringify(item.value) === userSelectedTimeRange)?.label
        setDateValues({ label: currentDateValue })
        setCurrentCycle(currentDateValue)
        const userSelectedTimeRangeIndex = weekOptions.findIndex(item => JSON.stringify(item.value) === userSelectedTimeRange)
        // 判断是不是选中最后一个周期，此时上个周期设置为''
        if (userSelectedTimeRangeIndex === weekOptions.length - 1) {
          setLastCycle('')
        } else if (userSelectedTimeRangeIndex === 0) {
          setLastCycle('上个7天')
        } else {
          setLastCycle(weekOptions[userSelectedTimeRangeIndex + 1].label)
        }

        await getCycleEnergyData(vin, timeRange[0], timeRange[1], userSelectedTimeRangeIndex)
      } else {
        // 首次进入页面默认选择最近7天
        timeRange = weekOptions[0].value
        setDateValues({ label: weekOptions[0].label })
        setCurrentCycle(weekOptions[0].label)
        setLastCycle('上个7天')

        await getCycleEnergyData(vin, timeRange[0], timeRange[1])
      }
      handleLoading(false)
    } catch (error) {
      handleLoading(false)
    }
  }

  /**
   * 当url不带vin参数时，说明是从消息推送入口进来，此时会带vehicleTypeName车型参数
   * 逻辑上先查到当前用户作为主使用人的车辆列表，过滤出相应车型的list，取第一台车的vin查getUserVehicleInfo
   */
  const getUserVehicleList = () => {
    return new Promise<any>((resolve, reject) => {
      getVehicleList().then((res: any) => {
        if (res.code === 200) {
          const vehicleList = res.data || []
          const filterVehicleTypeList = vehicleList.filter(item => item?.vehicleTypeName === queryVehicleTypeName)
          if (filterVehicleTypeList?.length > 0) {
            currentVin.current = filterVehicleTypeList[0].vin
          } else {
            setErrorMsg('暂无更多数据')
            setIsEmptyPage(true)
          }
          resolve('')
        } else {
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsEmptyPage(true)
          reject()
        }
      }).catch(err => {
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsLoadingError(true)
        reject(err)
      })
    })
  }

  const getUserVehicleInfo = (vin: string) => {
    return new Promise<any>((resolve, reject) => {
      getVehicleInfo({ vin }).then(res => {
        if (res.code === 200) {
          const vehicleList = res.data || []
          const matchedVehicleInfo = vehicleList.find(item => item.vin === vin)
          // VIN码匹配有误，兜底
          if (!matchedVehicleInfo) {
            setErrorMsg('VIN码匹配有误')
            setIsEmptyPage(true)
            reject()
            return
          }
          // 当前车辆不支持查看能耗报告
          if (!matchedVehicleInfo.supported) {
            setErrorMsg('暂不支持查看该车型能耗数据')
            setIsEmptyPage(true)
            reject()
            return
          }
          // 当前车辆人车绑定时间为今天
          const todayTimestamp = new Date().setHours(0,0,0,0) // 当天0点时间戳
          if (matchedVehicleInfo.validStartTime >= todayTimestamp) {
            setErrorMsg('能耗数据尚未生成')
            setIsEmptyPage(true)
            reject()
            return
          }
          setVehicleList(vehicleList)
          setCurrentVehicleInfo(matchedVehicleInfo)
          // 返回该车的人车绑定时间
          // resolve(matchedVehicleInfo.validStartTime)
          resolve(matchedVehicleInfo)
        } else {
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsEmptyPage(true)
          reject(new Error(res?.msg))
        }
      }).catch(err => {
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsLoadingError(true)
        reject(err)
      })
    })
  }

  const handleWeekOptionsData = (validStartTime: number, validEndTime) => {
    const weekOptions = getWeekOptionsForEnergyInfo(validStartTime, validEndTime)
    weekOptions.forEach((item, index) => {
      // 最近7天选项数据格式不修改
      if (index > 0) item.label = getLegendLabel(item.label)
    })
    return weekOptions
  }

  const getCycleEnergyData = (vin, startTime, endTime, currentCycleIndexInWeekOptions?: number) => {
    return new Promise<any>((resolve, reject) => {
      const params = isSuperErev ? { vin, startTime, endTime, isSuperErev } : { vin, startTime, endTime }
      getWeekEnergyData(params)
      .then(res => {
        if (res.code === 200) {
          setEnergyDataSummary(res.data)
          formatCycleEnergyData(res.data, currentCycleIndexInWeekOptions)
          isSuperErev && formatSuperErevEcharsOption(res.data, currentCycleIndexInWeekOptions)
        } else {
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsEmptyPage(true)
        }
        resolve(true)
      }).catch(err => {
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsLoadingError(true)
        reject(err)
      })
    })
  }

  const formatCycleEnergyData = (energyData, selectedWeekIndex = 0) => {
    const resData = energyData
    const dayList: any[] = []
    const currentCycleDateList: any[] = []
    const currentCycleData: any[] = []
    const lastCycleDateList: any[] = []
    const lastCycleData: any[] = []

    // 行驶折线图某些数据为空时，展示为0

    resData.drivePowerDetailsByDays?.thisCycleDetails?.forEach((item) => {
      currentCycleDateList.push(item.date)
      // let arr = [-16.3, 12.5, 12.3, 13.6, 12.5, 13.8, 14.0]
      // item.avgPower = arr[Math.floor(Math.random()*7)]
      currentCycleData.push(formatEnergyData(item.avgPower || 0))
    })
    resData.drivePowerDetailsByDays?.lastCycleDetails?.forEach((item) => {
      lastCycleDateList.push(item.date)
      // let arr = [12.1, 12.1, 13.1, 12.8, 11.5, 13.5, 13.1]
      // item.avgPower = arr[Math.floor(Math.random()*7)]
      lastCycleData.push(formatEnergyData(item.avgPower || 0))
    })

    handleSetLine(selectedWeekIndex, currentCycleDateList, currentCycleData, lastCycleDateList, lastCycleData)

    currentCycleDateList.length && currentCycleDateList.forEach(date => {
      dayList.push(getDay(date))
    })
    setXLabels(dayList)

    // console.log({
    //   currentCycleDateList,
    //   currentCycleData,
    //   lastCycleDateList,
    //   lastCycleData
    // })

    // 获取能耗分布top5数据
    const driveCycleData: any[] = []
    const parkingCycleData: any[] = []

    // 计算行车能耗分布数据
    resData.energyUsageDetail?.driveConsumptionThisCycle?.forEach(item => {
      driveCycleData.push({
        type: item.type,
        thisCycleValue: item.value,
        energyRatio: calcRatio(item.value, resData?.energyUsageDetail?.driveTotalConsumption)
      })
    })
    resData.energyUsageDetail?.driveConsumptionLastCycle?.forEach((item, index) => {
      driveCycleData[index] && (driveCycleData[index].rangeOfChange = calcRange(driveCycleData[index]?.thisCycleValue, item.value))
    })
    // 计算停车能耗分布数据
    resData.energyUsageDetail?.parkingConsumptionThisCycle?.forEach(item => {
      parkingCycleData.push({
        type: item.type,
        thisCycleValue: item.value,
        energyRatio: calcRatio(item.value, resData.energyUsageDetail?.parkingTotalConsumption)
      })
    })
    resData.energyUsageDetail?.parkingConsumptionLastCycle?.forEach((item, index) => {
      parkingCycleData[index] && (parkingCycleData[index].rangeOfChange = calcRange(parkingCycleData[index]?.thisCycleValue, item.value))
    })

    driveEnergyDistributionData.current = driveCycleData
    parkingEnergyDistributionData.current = parkingCycleData
    setDistributionType('drive')

    // console.log({
    //   driveCycleData,
    //   parkingCycleData
    // })
  }

  const handleSetLine = (
    selectedWeekIndex: number,
    currentCycleDateList: string[],
    currentCycleData: any[],
    lastCycleDateList: string[],
    lastCycleData: any[]
  ) => {
    // 取最大值和最小值，计算y轴刻度间隔
    const currentCycleAvgPower= currentCycleData.map(item => parseFloat(item))
    const lastCycleAvgPower = lastCycleData.map(item => parseFloat(item))
    // dateList格式为xxxx-xx-xx，只展示月份和日期：xx/xx
    const curDateList = currentCycleDateList.map(date => date.split('-')[1] + '/' + date.split('-')[2])
    const lastDateList = lastCycleDateList.map(date => date.split('-')[1] + '/' + date.split('-')[2])

    // 选中“最近7天”，上个周期手动填充为“上个7天”
    if (selectedWeekIndex === 0) {
      setLineData([
        { timeRange: '最近7天', timeList: curDateList, data: currentCycleData },
        { timeRange: '上个7天', timeList: lastDateList, data: lastCycleData }
      ])
      setMaxAvgPower(Math.max(...currentCycleAvgPower, ...lastCycleAvgPower))
    } else if (selectedWeekIndex === timeRangeOptions.current.length - 1) {
      // 选中最远的一个自然周，lineData只留该周数据
      setLineData([
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex]?.label), timeList: curDateList, data: currentCycleData }
      ])
      setMaxAvgPower(Math.max(...currentCycleAvgPower))
    } else {
      setLineData([
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex]?.label), timeList: curDateList, data: currentCycleData },
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex + 1]?.label), timeList: lastDateList, data: lastCycleData }
      ])
      setMaxAvgPower(Math.max(...currentCycleAvgPower, ...lastCycleAvgPower))
    }
  }


  const formatSuperErevEcharsOption = (energyData, selectedWeekIndex = 0) => {
    const resData = energyData
    const dayList: any[] = []
    const currentFuelCycleDateList: any[] = []
    const currentFuelCycleData: any[] = []
    const lastFuelCycleDateList: any[] = []
    const lastFuelCycleData: any[] = []


    resData.drivePowerDetailsByDays?.thisCycleFuelDetails?.forEach((item) => {
      currentFuelCycleDateList.push(item.date)
      currentFuelCycleData.push(formatEnergyData(item.avgFuel || 0))
    })
    resData.drivePowerDetailsByDays?.lastCycleFuelDetails?.forEach((item) => {
      lastFuelCycleDateList.push(item.date)
      lastFuelCycleData.push(formatEnergyData(item.avgFuel || 0))
    })

    handleSetSuperErevLine(
      selectedWeekIndex,
      currentFuelCycleDateList,
      currentFuelCycleData,
      lastFuelCycleDateList,
      lastFuelCycleData
    )

    currentFuelCycleDateList.length && currentFuelCycleDateList.forEach(date => {
      dayList.push(getDay(date))
    })
    setSuperErevXLabels(dayList)
  }

  const handleSetSuperErevLine = (
    selectedWeekIndex: number,
    currentCycleDateList: string[],
    currentCycleData: any[],
    lastCycleDateList: string[],
    lastCycleData: any[]
  ) => {
    // 取最大值和最小值，计算y轴刻度间隔
    const currentCycleAvgPower= currentCycleData.map(item => parseFloat(item))
    const lastCycleAvgPower = lastCycleData.map(item => parseFloat(item))
    // dateList格式为xxxx-xx-xx，只展示月份和日期：xx/xx
    const curDateList = currentCycleDateList.map(date => date.split('-')[1] + '/' + date.split('-')[2])
    const lastDateList = lastCycleDateList.map(date => date.split('-')[1] + '/' + date.split('-')[2])

    // 选中“最近7天”，上个周期手动填充为“上个7天”
    if (selectedWeekIndex === 0) {
      setSuperErevLineData([
        { timeRange: '最近7天', timeList: curDateList, data: currentCycleData },
        { timeRange: '上个7天', timeList: lastDateList, data: lastCycleData }
      ])
      setSuperErevMaxAvgPower(Math.max(...currentCycleAvgPower, ...lastCycleAvgPower))
    } else if (selectedWeekIndex === timeRangeOptions.current.length - 1) {
      // 选中最远的一个自然周，lineData只留该周数据
      setSuperErevLineData([
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex]?.label), timeList: curDateList, data: currentCycleData }
      ])
      setSuperErevMaxAvgPower(Math.max(...currentCycleAvgPower))
    } else {
      setSuperErevLineData([
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex]?.label), timeList: curDateList, data: currentCycleData },
        { timeRange: getLegendLabel(timeRangeOptions.current[selectedWeekIndex + 1]?.label), timeList: lastDateList, data: lastCycleData }
      ])
      setSuperErevMaxAvgPower(Math.max(...currentCycleAvgPower, ...lastCycleAvgPower))
    }
  }

  const confirmDateRange = async () => {
    const selectedTimeRange = timeRangeOptions.current.find(item => item.label === dateValues.label)!
    const selectedWeekIndex = timeRangeOptions.current.findIndex(item => item.label === dateValues.label)
    console.log({ selectedTimestamp: selectedTimeRange?.value })

    // 保存用户选择的时间周期，从后续页面返回的时候判断是否存在会话存储，有则按该周期查询数据
    sessionStorage.setItem('selectedTimeRange', JSON.stringify(selectedTimeRange.value))

    setCurrentCycle(dateValues.label)
    setShowDateRangePicker(false)
    if (selectedWeekIndex === 0) {
      setLastCycle('上个7天')
    } else if (selectedWeekIndex !== timeRangeOptions.current.length - 1) {
      setLastCycle(getLegendLabel(timeRangeOptions.current[selectedWeekIndex + 1]?.label))
    } else {
      setLastCycle('')
    }

    try {
      handleLoading(true)
      await getCycleEnergyData(
        currentVehicleInfo.vin,
        selectedTimeRange.value[0],
        selectedTimeRange.value[1],
        selectedWeekIndex
      )
      handleLoading(false)
    } catch (error) {
      handleLoading(false)
    }

    // 选择时间周期埋点
    reportData({pageId: 'P11140', buttonId: 'B002', vin: currentVehicleInfo.vin, params: {
      option: dateValues.label
    }})
  }

  const cancelDateRange = () => {
    setShowDateRangePicker(false)
    setDateValues({ label: currentCycle })
  }

  /**
   * 本来是展示 x月第x周（xx.xx~xx.xx），产品后面改成除了最近7天以外只展示xx.xx~xx.xx，这里特殊做截取处理
   * @param label 
   * @returns 
   */
  const getLegendLabel = (label) => {
    if (!label) return '--'
    const matchedStr = label.match(/（(\S*)）/)
    return matchedStr?.length > 1 ? matchedStr[1] : label
  }

  const getDay = (date: string) => {
    if (!date) return '--'

    const day = new Date(date).getDay()
    if (day === 0) return '周日'
    return `周${WEEK_LIST[day - 1]}`
  }

  /**
   * 计算能耗变化幅度，两周期数据都为0展示0，本周数据为0展示下降100%，上周数据为0表示上涨100%，任一数据异常展示'--'
   * 保留一位小数
   */
  const calcRange = (thisCycleValue, lastCycleValue) => {
    if (isErrorData(thisCycleValue) || isErrorData(lastCycleValue)) {
      return '--'
    }
    if (thisCycleValue === 0 && lastCycleValue === 0) {
      return 0
    }
    if (thisCycleValue === 0) {
      return -100
    }
    if (lastCycleValue === 0) {
      return 100
    }

    if (lastCycleValue === 0) return '--'

    const changeRange = (((+thisCycleValue - +lastCycleValue) / +lastCycleValue) * 100).toFixed(1)

    return Number(changeRange)
  }

  const reloadPage = () => {
    window.location.reload()
  }

  const showMessageBox = (title: string, message: string, confirmButtonText = '知道了') => {
    MessageBox.alert(message, { title, confirmButtonText })
  }

  // const showEnergyRecoveryTips = () => {
  //   showMessageBox('能量回收', '“行程耗电”为行程中的实际耗电量，行程耗电+能量回收电量=行程总输出电量')
  // }

  const showOtherTips = (type: string) => {
    let title = ''
    let desc = ''
    if (type === 'drive') {
      title = '行程-其他'
      desc = '其他行驶期间的用电器，如车灯、大屏、音响等。'
    }
    if (type === 'parking') {
      title = '停车-其他'
      // desc = '非行驶状态时车辆各控制器的基础耗电，包括车辆上电到行驶前的基础耗电，以及锁车下电后的基础耗电。'
      desc = '车辆从锁车下电到下次驶动期间，车辆各控制器和其他用电器的基础耗电。'
    }
    showMessageBox(title, desc)
  }

  const handleLoading = (loading: boolean) => {
    setIsLoading(loading)
  }

  // const handleConfirmVehicle = async (item: vehicleItem) => {
  //   setShowVehiclePicker(false)
  //   if (item.vin !== currentVehicleInfo.vin) {
  //     setCurrentVehicleInfo(item)

  //     const weekOptions = handleWeekOptionsData(item.validStartTime, item.validEndTime)
  //     const timeRange = weekOptions[0].value

  //     try {
  //       handleLoading(true)
  //       await getCycleEnergyData(item.vin, timeRange[0], timeRange[1])
  //       handleLoading(false)
  //     } catch (error) {
  //       handleLoading(false)
  //     }
  //   }
  // }

  const handleChangeDate = (name, value) => {
    if (name === 'label') {
      setDateValues({ label: value })
    }
  }

  /**
   * 行程/停车类型点击事件，由于会做埋点上报，点击触发时做300s防抖不会频繁发送上报请求
   * @param type
   */
  const handleClickEnergyType = (type: string) => {
    setDistributionType(type)

    const TYPE_MAP = {
      'drive': '行程',
      'parking': '停车'
    }

    clearTimeout(debounceTimer.current)
    debounceTimer.current = setTimeout(() => {
      // 行车/停车切换点击埋点
      reportData({pageId: 'P11140', buttonId: 'B003', vin: currentVehicleInfo.vin, params: {
        option: TYPE_MAP[type]
      }})
    }, 300)
  }

  const goToDateListPage = () => {
    const selectedTimeRange = timeRangeOptions.current.find(item => item.label === dateValues.label)!

    // 单日详情按钮点击埋点
    reportData({ pageId: 'P11140', buttonId: 'B004', vin: currentVehicleInfo.vin })

    // 延时跳转，等数据上报
    setTimeout(() => {
      history.push(`/car-service/energy_report/date-list?vin=${currentVehicleInfo.vin}&lastDay=${selectedTimeRange.value[1]}&validEndTime=${currentVehicleInfo.validEndTime}&isSuperErev=${isSuperErev}`)
    }, 300)
  }

  /**
   * 与服务端约定，将需要高亮的字符左右加上指定标签如：<hl>123</hl>
   * 前端将hl标签替换为<span style="color:#89B843">123</span>，直接以html模板字符串渲染
   * @param text 
   */
  const formatConclusions = (text: string) => {
    if (!text) return '<span></span>'
    text = text.replace(/<hl>/g, '<span style="color:#89B843">').replace(/<\/hl>/g, '</span>')
    return `<span>${text}</span>`
  }

  const showCycleEnergyTips = () => {
    const title = isSuperErev ? '平均行车电耗' : '平均行车能耗' 
    const messageConent = isSuperErev ? 
      '指车辆在车速>0期间的综合电耗，包括电驱系统、空调、各类用电器等，按行程的总里程统计。' : 
      '指车辆在车速>0期间的综合能耗，包括电驱系统、空调、各类用电器等。'
    showMessageBox(title, messageConent)
  }

  const showCycleFuelTips = () => {
    showMessageBox('平均行车油耗', '指车辆在增程器启动期间的综合油耗，包括电池充电、电驱系统、空调、各类用电器等，按行程的总里程统计。')
  }

  const showEnergyDistributionTips = () => {
    // 增程车 纯电能量分布 tips 差异化
    const tripConsumptionText = isSuperErev ? '2. 行程耗电=行程总输出电量（含燃油发电量）-能量回收电量。' : '2. 行程耗电=行程总输出电量-能量回收电量。'
    const message  =  <><div>1. 行程耗电指车辆从开始驶动到锁车下电整个行程的耗电量。</div><div>{tripConsumptionText}</div><div>3. 停车耗电指车辆从锁车下电到下次驶动整个过程的耗电量。</div></>
    const title = '能耗分布'
    const confirmButtonText = '知道了'
    const className = 'energy-distribution-tips'
    MessageBox.alert(message, {title, confirmButtonText, className})
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab)
    
    // 使用 setTimeout 确保 DOM 更新完成
    setTimeout(() => {
      if (tab === 'electric') {
        renderChart(lineChartRef, lineChartOption, 'electric')
      } else {
        renderChart(superErevChartRef, superErevlineChartOption, 'fuel')
      }
    }, 0)
  }

  // if (isLoading)
  //   return (
  //     <div className={styles.loadingPage}>
  //       <div className={styles.blank1}></div>
  //       <div className={styles.blank2}></div>
  //       <div className={styles.blank3}></div>
  //       <HomePageLoading></HomePageLoading>
  //     </div>
  //   )

  if (isLoading)
    return (
      <LoadingPage />
    )

  if (isLoadingError)
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={reloadPage}
      ></ErrorPlaceholder>
    )

  if (isEmptyPage)
    return (
      <EmptyPlaceholder text={errorMsg}></EmptyPlaceholder>
    )
  
  if (beforeInit) {
    return (
      <div className={styles.emptyPage}></div>
    )
  }

  const {
    avgCircumstanceTemperature,
    avgDriveSpeed,
    totalDriveMileage,
    updateTime,
    conclusions,
    totalElectricMileage,
    totalFuelMileage
  } = energyDataSummary
  // 解构第二层对象可能取到undefined导致抛异常白屏，这里用可选链操作符安全获取各数据
  const avgPowerOfThisCycle = energyDataSummary?.drivePowerDetailsByDays?.avgPowerOfThisCycle
  const avgPowerOfLastCycle = energyDataSummary?.drivePowerDetailsByDays?.avgPowerOfLastCycle
  const avgPowerChangePercent = calcRange(avgPowerOfThisCycle, avgPowerOfLastCycle)
  
    // 增程车本周平局油耗与上周期平局油耗
  const avgFuelOfThisCycle = energyDataSummary?.drivePowerDetailsByDays.avgFuelOfThisCycle
  const avgFuelOfLastCycle = energyDataSummary?.drivePowerDetailsByDays.avgFuelOfLastCycle
  const avgFuelChangePercent = calcRange(avgFuelOfThisCycle, avgFuelOfLastCycle)

  const driveTotalConsumption = energyDataSummary?.energyUsageDetail?.driveTotalConsumption
  const parkingTotalConsumption = energyDataSummary?.energyUsageDetail?.parkingTotalConsumption
  const totalConsumption = energyDataSummary?.energyUsageDetail?.totalConsumption
  const recycledEnergy = energyDataSummary?.energyUsageDetail?.recycledEnergy

  const distributionData = distributionType === 'drive' ? driveEnergyDistributionData.current : parkingEnergyDistributionData.current

  return (
    <div className={styles.homePage}>
      <div className={styles.topbar} onClick={hideEchartsTooltip}>
        <div className={styles.vehicleInfo}>
          <div className={styles.plateNo}>
            {currentVehicleInfo.vehicleTypeSaleName} {currentVehicleInfo.plateNo ? formatVehiclePlate(currentVehicleInfo.plateNo) : desensitizedVin(currentVehicleInfo.vin)}
          </div>
          {/* { vehicleList.length > 1 ? <div className={styles.arrowDown}></div> : null } */}
        </div>
        <div className={styles.weekInfo} onClick={() => setShowDateRangePicker(true)}>
          <div className={styles.currentWeek}>{currentCycle}</div>
          <div className={styles.arrowDown}></div>
        </div>
      </div>
      <div className={styles.comprehensiveData}>
        <div className={styles.title}>综合数据</div>
        <div className={styles.avgDataBlock}>
          <div className={styles.dataArea}>
            <div className={styles.avgData}>
              <span className={styles.avgPowerNum}>{formatEnergyData(avgPowerOfThisCycle)}</span>
              {
                lastCycle ? 
                <>
                  {
                    typeof avgPowerChangePercent === 'number' ?
                    <>
                      <div className={styles.iconContainer}>
                        <span className={`${styles.changeNum} ${avgPowerChangePercent <= 0 ? styles.decrease : ''}`}>
                          <div className={`${styles.changeArrow} ${avgPowerChangePercent <= 0 ? styles.decrease : ''}`}></div>
                          {Math.abs(avgPowerChangePercent)}%
                        </span>
                      </div>
                    </> : null
                  }
                </> : null
              }
            </div>
            <div className={styles.cycleEnergy} onClick={showCycleEnergyTips}>
              {isSuperErev ? '平均电耗': '平均行车能耗'}{'(kWh/100km)'}
              <div className={styles.helpIcon}></div>
            </div>
          </div>
          {
            isSuperErev && 
            <div className={styles.dataArea}>
              <div className={styles.avgData}>
                <span className={styles.avgPowerNum}>{formatEnergyData(avgFuelOfThisCycle)}</span>
                {
                  lastCycle ? 
                  <>
                    {
                      typeof avgFuelChangePercent === 'number' ?
                      <>
                        <div className={styles.iconContainer}>
                          <span className={`${styles.changeNum} ${avgFuelChangePercent <= 0 ? styles.decrease : ''}`}>
                            <div className={`${styles.changeArrow} ${avgFuelChangePercent <= 0 ? styles.decrease : ''}`}></div>
                            {Math.abs(avgFuelChangePercent)}%
                          </span>
                        </div>
                      </> : null
                    }
                  </> : null
                }
              </div>
              <div className={styles.cycleEnergy} onClick={showCycleFuelTips}>
                平均油耗{'(L/100km)'}
                <div className={styles.helpIcon}></div>
              </div>
            </div>
          }
        </div>
        {
          isSuperErev ?
          <div className={styles.fuelDataContainer}>
            <div className={styles.dividingLine}></div>
            {/* <div className={styles.percentageContainer}>
              <div className={styles.iconWrapper}>
                <div className={styles.mileageContiner}>
                  <div className={styles.powerIcon} />
                  <div className={styles.mileage}>{formatEnergyData(totalElectricMileage)}km</div>
                </div>
                <div className={styles.mileageContiner}>
                  <div className={styles.fuelIcon} />
                  <div className={styles.mileage}>{formatEnergyData(totalFuelMileage)}km</div>
                </div>
              </div>
              <div className={styles.ratioBars}>
                <div 
                  className={`${styles.ratioBar} ${styles.green}`}
                  style={{ width: '30%' }}
                >
                </div>
                
                <div 
                  className={`${styles.ratioBar} ${styles.blue}`}
                  style={{ width: '70%'}}
                >
                </div>
              </div>
            </div> */}
            <div className={styles.driveDataContainer}>
              <div className={styles.driveData}>
                <div className={styles.label}>行驶里程</div>
                <div className={styles.data}>{formatEnergyData(totalDriveMileage)}km</div>
              </div>
              <div className={styles.driveData}>
                <div className={styles.label}>平均车速</div>
                <div className={styles.data}>{formatEnergyData(avgDriveSpeed)}km/h</div>
              </div>
            </div>
          </div> : 
          <div className={styles.dataRow}>
            <div className={styles.dataItem}>
              <div className={styles.num}>{formatEnergyData(totalDriveMileage)}</div>
              <div className={styles.dataName}>行驶里程{'(km)'}</div>
            </div>
            <div className={styles.dataItem}>
              <div className={styles.num}>{formatEnergyData(totalConsumption)}</div>
              <div className={styles.dataName}>总耗电量{'(kWh)'}</div>
            </div>
            <div className={styles.dataItem}>
              <div className={styles.num}>{formatEnergyData(avgDriveSpeed)}</div>
              <div className={styles.dataName}>平均车速{'(km/h)'}</div>
            </div>
          </div>
        }
      </div>
      <div className={styles.energyTrend}>
        <div className={styles.title}>能耗趋势</div>
        {
          isSuperErev && 
            <div className={styles.energyTrendTabs}>
              <div className={styles.tabHeader}>
                <div
                  className={`${styles.tabBtn} ${activeTab === 'electric' ? styles.active : ''}`}
                  onClick={() => handleTabClick('electric')}
                >
                  电耗趋势
                </div>
                <div
                  className={`${styles.tabBtn} ${activeTab === 'fuel' ? styles.active : ''}`}
                  onClick={() => handleTabClick('fuel')}
                >
                  油耗趋势
                </div>
              </div >
            </div>
        }
        <div className={styles.trendDescRow}>
          <div className={styles.descItem}>单位：{ activeTab === 'electric' ? 'kWh/100km': 'L/100km' }</div>
          <div className={styles.descItem}>平均气温：{formatEnergyData(avgCircumstanceTemperature)}{'(℃)'}</div>
        </div>
        {
          isSuperErev ? 
            <>
              { activeTab === 'electric' ? 
                <div className={styles.chartContainer} ref={lineChartRef}></div> :
                <div className={styles.chartContainer} ref={superErevChartRef}></div>
              }
            </>
           : <div className={styles.chartContainer} ref={lineChartRef}></div>
        }
        {/* <div className={styles.chartContainer} ref={lineChartRef}></div> */}
      </div>
      <div className={styles.energyDistribution}>
        <div className={styles.title} onClick={showEnergyDistributionTips}>
          能耗分布
          <div className={styles.helpIcon}></div>
        </div>
        <div className={styles.dataRow}>
          <div className={styles.dataItem}>
            <div className={styles.num}>{formatEnergyData(driveTotalConsumption)}</div>
            <div className={styles.dataName}>行程耗电{'(kWh)'}</div>
          </div>
          <div className={styles.dataItem}>
            <div className={styles.num}>{formatEnergyData(parkingTotalConsumption)}</div>
            <div className={styles.dataName}>停车耗电{'(kWh)'}</div>
          </div>
        </div>
        <div className={styles.recovery}>
          <div className={styles.text}>
            已回收
            {/* <div className={styles.helpIcon}></div> */}
          </div>
          <div className={styles.data}>{formatEnergyData(recycledEnergy)}kWh</div>
        </div>
        <div className={styles.energyTypeBar}>
          <div className={`${styles.type} ${distributionType === 'drive' ? styles.active : ''}`} onClick={() => handleClickEnergyType('drive')}>行程</div>
          <div className={`${styles.type} ${distributionType === 'parking' ? styles.active : ''}`} onClick={() => handleClickEnergyType('parking')}>停车</div>
        </div>
        <div className={styles.dataDesc}>
          <span className={styles.energyType}>能耗类别</span>
          <span className={styles.powerConsumption}>耗电量</span>
          <span className={styles.changeRange}>变幅</span>
        </div>
        {
          distributionData.length > 0 ?
          distributionData.map((item, index) => (
            <div className={styles.energyDataBar} key={index}>
              <div className={styles.type}>
                {item.type}
                {index === distributionData.length - 1 ? <div className={styles.helpIcon} onClick={() => showOtherTips(distributionType)}></div> : null}
              </div>
              <div className={styles.dataInfo}>
                <div className={styles.percentBar}>
                  <div className={styles.highlightBar} style={{width:`${item.energyRatio}%`}}></div>
                </div>
                <div className={styles.dataContainer}>
                  <div className={styles.data}>{formatEnergyData(item.thisCycleValue)}kWh</div>
                  <div className={styles.changeData}>
                    {
                      lastCycle ?
                      <>
                        {
                          typeof item.rangeOfChange === 'number' ?
                          <>
                            {/* <div className={`${styles.icon} ${item.rangeOfChange <= 0 ? styles.decrease : ''}`}></div>
                            <div className={`${styles.num} ${item.rangeOfChange <= 0 ? styles.decrease : ''}`}>
                              {Math.abs(item.rangeOfChange) > 100 ?  '>100' : Math.abs(item.rangeOfChange)}%
                            </div> */}
                            <div className={`${styles.num} ${item.rangeOfChange <= 0 ? styles.decrease : ''}`}>
                              <div className={`${styles.icon} ${item.rangeOfChange <= 0 ? styles.decrease : ''}`}></div>
                              {Math.abs(item.rangeOfChange) > 100 ?  '>100' : Math.abs(item.rangeOfChange)}%
                            </div>
                          </> : <div className={styles.num}>--</div>
                        }
                      </> : <div className={styles.num}>--</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          )) : null
        }
        { lastCycle ? <div className={styles.remark}>{`(注：与${lastCycle}数据对比)`}</div> : null }
      </div>
      <div className={styles.suggestion}>
        <div className={styles.title}>分析与建议</div>
        {
          conclusions?.length > 0 ?
          conclusions.map((text, index) => (
            <div className={styles.desc} key={index} dangerouslySetInnerHTML={{__html: formatConclusions(text)}}></div>
          )) : <div className={styles.default}>{'暂无更多分析'}</div>
        }
      </div>
      <div className={styles.showSingleDate} onClick={goToDateListPage}>
        查看单日记录
        <div className={styles.arrowRight}></div>
      </div>
      <div className={styles.dataTips}>
        更新于：{formatTimestampToTxt(updateTime)}，每天凌晨更新前一日数据<br />
        数据源于云端，可能因车辆网络问题延迟上报，仅供参考
      </div>
      {showDateRangePicker && (
        <Picker
          title="周期选择"
          onCancel={cancelDateRange}
          onConfirm={confirmDateRange}
          onChange={handleChangeDate}
          valueGroups={dateValues}
          optionGroups={dateOptions}
          itemHeight={48}
        ></Picker>
      )}
      {/* {
        showVehiclePicker && (
          <VehiclePicker
            currentVin={currentVehicleInfo.vin}
            options={vehicleList}
            onConfirm={handleConfirmVehicle}
          ></VehiclePicker>
        )
      } */}
    </div>
  )
}

export default App